<template>
	<div class="bottomWrap">
		<img v-if="lang=='zh-cn'" :src="`${imgPath}/static/assets/img/bottom.jpg`" width="100%" />
		<img v-if="lang=='en-us'" :src="`${imgPath}/static/assets/img/bottom1.jpg`" width="100%" />
		<p style="text-align: center; margin-top: 0; padding-bottom: 0.1rem;"><a href="/wap/yinsizhengce.html" style="display: block; color: orange; font-size: 0.2rem; line-height: 0.3rem;">{{$t('privacy_policy')}}</a></p>
	</div>
</template>

<script>
	export default {
		name:'Bottom',
		data() {
			return {
				lang: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
			}
		},
		computed: {
			
		},
		created() {
			
		},
		methods: {
			
		}
	}
</script>
<style lang="scss" scoped>
.bottomWrap{
	position: relative;
	width: 100%;
	background: #000000;
	>img {
		display: block;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/bottom.vue